"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: credit-report/batch-context.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcredit-report%2Fbatch-context.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.BatchContext = void 0;
const credit_bureau_1 = require("../common/credit-bureau");
const protobufPackage = 'com.step.creditreport.proto';
function createBaseBatchContext() {
    return { bureaus: [] };
}
exports.BatchContext = {
    fromJSON(object) {
        const message = {};
        if (globalThis.Array.isArray(object?.bureaus)) {
            message.bureaus = object.bureaus.map((e) => (0, credit_bureau_1.creditBureauFromJSON)(e));
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.bureaus?.length) {
            obj.bureaus = message.bureaus.map((e) => (0, credit_bureau_1.creditBureauToJSON)(e));
        }
        return obj;
    },
    create(base) {
        return exports.BatchContext.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBatchContext();
        message.bureaus = object.bureaus?.map((e) => e) || [];
        return message;
    },
};
//# sourceMappingURL=batch-context.js.map